

  document.addEventListener("DOMContentLoaded", function() {
  
    window.SLIDECART_LOADED = function(cart) {
      checkCartValue(cart);
      checkCartContents(cart);
    }
    
    window.SLIDECART_UPDATED = function(cart) {
      checkCartValue(cart);
      checkCartContents(cart);
    }
    
    var checkCartValue = function(cart) {
      var items = cart.items;
      
      // Calculate the total value of non-gift card items
      var subTotal = items.reduce((total, item) => total + item.price * item.quantity, 0) / 100;

      let minOrderMessage = document.querySelector("#slidecarthq #minimum-order-message");

      if (items.length > 0) {
    
        if(!minOrderMessage) {
          const customHTML = document.querySelector('#slidecarthq #slidecart-checkout-form');
          const minOrderMessageElement = document.createElement('div');
          minOrderMessageElement.setAttribute('id', 'minimum-order-message');
          minOrderMessageElement.textContent = 'Please note, all Direct Seafood orders require a minimum of $100. Frozen items must total at least $100 to prevent thawing during transit.';
          customHTML.before(minOrderMessageElement); 
        }
        
        // Display appropriate messages based on the total values
        if (parseFloat(subTotal) > 0 && parseFloat(subTotal) < 100) {
          // If the subtotal is less than the minimum amount, hide the checkout button and show message
          document.querySelector("#slidecarthq #minimum-order-message").style.display = "block";
          document.querySelector("#slidecarthq #slidecart-checkout-form").style.display = "none";
        } else  {
          // If the subtotal is more than the minimum amount, hide the message and show checkout button
          document.querySelector("#slidecarthq #minimum-order-message").style.display = "none";
          document.querySelector("#slidecarthq #slidecart-checkout-form").style.display = "block";
        }
      } else {
        if(minOrderMessage) {
          document.querySelector("#slidecarthq #minimum-order-message").remove();
        }
      }
    };

    var checkCartContents = function(cart) {
      var items = cart.items;

      const keyToCheck = '__appstle-bb-name';
      const noItemHasSubscriptionKey = items.every(obj => !obj.properties.hasOwnProperty(keyToCheck));

      if (noItemHasSubscriptionKey) {
        document.querySelector("#slidecarthq .rewards").style.opacity = "1";
        document.querySelector("#slidecarthq .rewards").style.pointerEvents = "all";
      } else {
        document.querySelector("#slidecarthq .rewards").style.opacity = "0";
        document.querySelector("#slidecarthq .rewards").style.pointerEvents = "none";

        items.forEach((item) => {
          if (item.properties.hasOwnProperty('__appstle-bb-name')) {
            document.querySelector(".slidecarthq .items [data-line-item-key='" + item.key + "'] .quantity-selector").style.display = "none";
          }
          
        });
      }
    };
  });
